import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';
import { LabeledSwitch } from '../common';
const DefaultTermsOfServiceText = (props) => {
    return (_jsxs(Text, { testID: `${props.testID}-agree-text`, style: { marginHorizontal: 10 }, children: ["I agree to the", ' ', _jsx(Text, { testID: `${props.testID}-terms-of-service-link`, onPress: props.onShowTermsOfServicePressed, style: { textDecorationLine: 'underline' }, children: "Terms of Service" })] }));
};
export const TermsOfServiceSwitch = ({ testID, style, onShowTermsOfServicePressed, label = (_jsx(DefaultTermsOfServiceText, { testID: testID, onShowTermsOfServicePressed: onShowTermsOfServicePressed })), ...props }) => {
    const styles = StyleSheet.create({
        inputSpacing: {
            marginVertical: 5,
        },
    });
    return (_jsx(LabeledSwitch, { ...props, style: [styles.inputSpacing, style], right: label }));
};
